import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManGetAllDevidend() {
    return maintainRequest.get(`/user/maintenanceMan/dividend/getAgentAllDevidend`)
}
